import React, { Component } from "react"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
} from "shared/search/containers/Filter/Filters"

import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import { CaucusTypeFilter } from "shared/search/containers/Filter/CaucusFilters"

import { CommitteeOfficialFilter } from "shared/search/containers/Filter/CommitteeFilters"

export class CaucusTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [CaucusTypeFilter],
        uniqueFilterGroupId: "caucusTypeFilterGroup",
        displayLabel: "Caucus Type",
        helpText: "Filter caucuses by caucus type.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CaucusMemberFilterGroup extends Component {
    static defaultProps = {
        filters: [CommitteeOfficialFilter],
        uniqueFilterGroupId: "caucusMemberFilterGroup",
        displayLabel: "Members",
        helpText: "Filter caucuses by which legislators are members.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CaucusListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.caucus.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.caucus.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "caucusListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter caucuses by the lists you've saved to Projects.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CaucusProjectFilterGroup extends Component {
    static defaultProps = {
        filters: [inIssueFilter, notInIssueFilter],
        uniqueFilterGroupId: "caucusProjectFilterGroup",
        displayLabel: "Issues",
        helpText: "Filter for caucuses by tagged Issues.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
